
const getters = {
  staticText: (state) => (textKey) => {
    return state.staticTexts[textKey] || ''
  },

  storageUpdateDate: (state) => {
    return state.storageUpdateDate || {}
  },

  versions: (state) => {
    return state.versions || {}
  },

  crushingDrugs: (state) => {
    return state.crushingDrugs
  },

  crushingDrugForms: (state) => {
    return state.crushingDrugForms
  },

  eyedropDosages: (state) => {
    return state.eyedropDosages
  },

  eyedropGeneralRecommendation: (state) => {
    return state.eyedropGeneralRecommendation
  },

  generalRecText: (state) => {
    return state.generalRecText
  },

  applicationDynamicText: (state) => (recordKey) => {
    return state.applicationDynamicTexts[recordKey] || ''
  },

  drugById: (state) => (id) => {
    return state.crushingDrugs.filter(d => d.id === parseInt(id))[0]
  },

  references: (state) => {
    return state.references
  },

  referenceByName: (state) => (name) => {
    return state.references.filter(r => r.name === name)[0]
  },

  notes: (state) => {
    return state.notes
  },

  noteByName: (state) => (name) => {
    return state.notes.filter(n => n.name === name)[0]
  },

  dilutions: (state) => {
    return state.dilutions
  },

  dilutionById: (state) => (id) => {
    return state.dilutions.filter(d => d.id === parseInt(id))[0]
  },

  contentByKey: (state) => (key) => {
    return state.contents ? state.contents.filter(d => d.key === key)[0] : ''
  },

  surplusDrugStorage: (state) => {
    return state.surplusDrugStorage
  },

  surplusDrugStorageLocations: (state) => {
    return state.surplusDrugStorageLocations
  },

  reducedKidneyFunctionDrugById: (state) => (id) => {
    return state.reducedKidneyFunctionDrugs.filter(d => d.id === parseInt(id))[0]
  },

  pdf: (state) => {
    return state.pdf
  }
}

export default getters
